import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findNoticeList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/notice?` + params,
        method: 'GET'
    })
}

export const addNotice = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/notice`,
        method: 'POST',
        data: data
    })
}
export const editNotice = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/notice`,
        method: 'PUT',
        data: data
    })
}
export const delNotice = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/notice/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}
export const startRule = (id) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/rule/startRule/${id}`,
        method: 'GET'
    })
}
export const stopRule = (id) => {
    return request({
        url: `${baseUrl}/joins-cluster/v1/rule/stopRule/${id}`,
        method: 'GET'
    })
}